


















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from '@/shared/app.constants';
import UserProfileComponent from "./Components/UserProfile.vue";
import ChangePasswordComponent from "./Components/ChangePassword.vue";
import { http } from "@/shared/https";
import AuthService from "@/services/auth.service";

const auth = new AuthService();

@Component({
    components: {
        UserProfileComponent,
        ChangePasswordComponent
    }
})
export default class UserInformationComponent extends Vue {  
    public Name: string = "loading...";
    public Email: string = "loading...";
    public Status: string = "";
    public snackColor: string = "";
    public snackBar: boolean = false;
    private selectedFile: any;
    public fileName: string = "";
    public Imageurl: any = "";
    public Acronym: string = "";
    public PreferredLanguageId: Int32Array;
   
    @Prop() showUpload: boolean = false;

    get avatarChanged(): any {
        return this.showUpload;
    }
    
    // Selecting Profile pic
  onFileChanged(event): void {
    this.selectedFile = event.target.files[0];
    this.fileName = this.selectedFile.name;

    let input = event.target;

    if (input.files && input.files[0]) {
      // create a new FileReader to read this image and convert to base64 format
      let reader = new FileReader();
      // Define a callback function to run, when FileReader finishes its job
      reader.onload = (e) => {
        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
        // Read image as base64 and set to imageData
        this.Imageurl = e.target.result;
      };

      // Start the reader job - read file as a data url (base64 format)
      reader.readAsDataURL(input.files[0]);

      this.showUpload = true;
    }
  }

  // Upload profile picture
  uploadAvatar(): void {
    const formData = new FormData();
    formData.append("file", this.selectedFile, this.selectedFile.name);

    http.post("/api/Profile", formData, "multipart/form-data").then((resp) => {
      if (resp.status >= 200 && resp.status < 300) {
        this.showUpload = false;
        let data = resp.data.Value;

        if (data.Result == "OK") {
          this.Imageurl = data.Image;
          this.snackBar = true;
          this.Status = data.Message;
          this.snackColor = "green";
        } else {
          this.snackBar = true;
          this.Status = data.Message;
          this.snackColor = "red darken-2";
        }
      } else {
        this.snackBar = true;
        this.Status = "Error occurred.";
        this.snackColor = "red darken-2";
      }
    });
  }

  //This function retrives the userprofile informations and populate the user information card
  created() {
    auth.isLoggedIn().then((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        auth.getUser().then((user) => {
          http.get(`/api/Profile/${user.profile.sub}`).then((resp) => {
            if (resp.status >= 200 && resp.status < 300) {
              var data = resp.data;
              this.Name = data.Name;
              this.Email = data.Email;
              this.PreferredLanguageId = data.PreferredLanguageId;
              let matches = user.profile.given_name.match(/\b(\w)/g);
              this.Acronym = matches.join("");
              this.Imageurl = data.Image;              
            } else {
            }
          });
        });
      }
    });
  }
}
